import { render, staticRenderFns } from "./fileOrder.vue?vue&type=template&id=68765298&scoped=true&"
import script from "./fileOrder.vue?vue&type=script&lang=js&"
export * from "./fileOrder.vue?vue&type=script&lang=js&"
import style0 from "./fileOrder.vue?vue&type=style&index=0&id=68765298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68765298",
  null
  
)

export default component.exports